import { z } from 'zod';

// the amount inputs hold null while empty, which must still fail with the standard "required" message
export const schemaRequiredAmount = z
    .number()
    .nullable()
    .superRefine((amount, ctx) => {
        if (amount === null)
            ctx.addIssue({ code: z.ZodIssueCode.invalid_type, expected: 'number', received: 'undefined' });
    });
